export const cityDataAction = (payload) => {
    return {
        type : "CITY_DATA",
        payload
    }
}